import { Alteracoes } from '../base';
import { Cidade } from '../endereco.model';
import { Moeda } from '../gerenciamento/moeda.model';
import { ServicoOfflinePergunta } from '../gerenciamento/servicooffline.model';

// tslint:disable: no-use-before-declare

export class Servico {
    public Id: number;
    public Titulo: string;
    public descricao: string;
    public selecionado: boolean;
    public CodigoFornecedor: any;
    public DiasSemana: any;
    public ListDiasSemana: any;
    public Tarifas: any;
    public DataSelecionada: any;
    public DatasDisponiveis: any;
    public MinimoPessoas: number;
    public MaximoPessoas: number;
    public De: any;
    public Ate: any;
    public Adt: number;
    public Chd: number;
    public CategoriaServico: number;
    public Status: number;
    public PrazoCancelamento: string;
    public Localizador: string;
    public PoliticaCancelamento: string;
    public Descricao: string;
    public Fornecedor: string;
    public ValorListagem: number;
    public Alteracoes: Alteracoes;
    public Cidade: Cidade;
    public ExtraIntegracao2: ExtraIntegracao;
    public MoedaListagem: Moeda;
    public MoedaFechameno: Moeda;
    public MoedaNet: Moeda;
    public Perguntas: ServicoOfflinePergunta[] = [];
    public ReservaId: number;
}

export enum TIPO {
    ATIVIDADE,
    INGRESSO,
    TRANSFER,
}

export class BuscaServicoRQ {
    public De: any;
    public Ate: any;
    public Adt: number;
    public IdadesChd: number[] = [];
    public Cidade: Cidade = new Cidade();
    public TipoServico: TIPO;
    public Guid: string;
    public AgenciaId: any;
    public ReservaId: any;
    public FiltroServico: FiltroServico = new FiltroServico();
    public ServicoExclusivo: boolean = false;
}

class ExtraIntegracao {
    public NomeFornecedor: string;
    public EnderecoFornecedor: string;
    public TelefoneFornecedor: string;
    public CidadeFornecedor: string;
    public EstadoFornecedor: string;
    public PaisFornecedor: string;
    public Token: string;
    public CategoriaServico: string;
}

export class FiltroServico {
  public ValorMinimo: number;
  public ValorMaximo: number;
  public Titulo: string;
  public TipoServico: string = "";
  public Tipo: string = ""
  public Categoria : number = -1;
  public Fornecedores: string[] = [];
}

export enum tipoServico {
    ATIVIDADE = 0,
    TICKET = 1,
    TRANSFER = 2,
}

export class ExtraIntegracaoValoresBusca {
    public Data: string;
    public Ingresso: Ingresso;
    public Horario: string;
    public CarrinhoId: string;
}

class Ingresso {
    public Id: number;
    public Nome: string;
    public Categorias: Categoria[];
}

class Categoria {
    public Id: number;
    public Quatidade: number;
    public Nome: string;
    public PrecoListagem: number;
    public PrecoNet: number;
}
